export default __webpack_public_path__ + "static/media/doctor.f69e9877.jpg";